import { Pipe, PipeTransform } from '@angular/core';
import { AnalyticsColumn } from '../../models/analytics-column';


@Pipe({
  name: 'sortFilter'
})
export class SortFilterPipe implements PipeTransform {

  transform(columns: AnalyticsColumn[]): any {   
    if(!columns) return columns;

    return columns.filter(item => item.visible);
  }
}